module.exports = __webpack_public_path__ + "media/2.c1914d1f.mp3";